import { render, staticRenderFns } from "./NewPlanCard.vue?vue&type=template&id=5083ae00&scoped=true"
import script from "./NewPlanCard.vue?vue&type=script&lang=js"
export * from "./NewPlanCard.vue?vue&type=script&lang=js"
import style0 from "./NewPlanCard.vue?vue&type=style&index=0&id=5083ae00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5083ae00",
  null
  
)

export default component.exports